module.exports = __webpack_public_path__ + "static/media/speedometer.c2fa8561.svg";